"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ICON_SET = exports.ICON_SETS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ICON_SETS;

var ICON_SETS = (_ICON_SETS = {}, (0, _defineProperty2.default)(_ICON_SETS, 'fontawesome-5', 'fontawesome-5'), (0, _defineProperty2.default)(_ICON_SETS, 'fontawesome-5.0.10', 'fontawesome-5.0.10'), (0, _defineProperty2.default)(_ICON_SETS, 'fontawesome-5.14.0', 'fontawesome-5.14.0'), _ICON_SETS);
exports.ICON_SETS = ICON_SETS;
var DEFAULT_ICON_SET = ICON_SETS['fontawesome-5.0.10'];
exports.DEFAULT_ICON_SET = DEFAULT_ICON_SET;